import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const userStatusReportList = createAsyncThunk('userStatusReport/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `user_report`,
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const generateUserStatusReport = createAsyncThunk('userStatusReport/generate', async ({ values }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + `user_report/excel`,
            data: {
                premise_id: values?.premise,
                role_id: values?.role,
                status: values?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const userStatusReportSlice = createSlice({
    name: 'userStatusReport',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(userStatusReportList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }
        });
        builder.addCase(userStatusReportList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default userStatusReportSlice.reducer;